const pathRewrite = '/api'
let topic = {
    userTopic: pathRewrite +'/cust', // 用户管理
    adminTopic: pathRewrite +'/admin', // 用户管理
};
export default  topic;